export enum WhatsappCodeRouting {
    FLOW = 'whatsapp-routing',
}
